module.exports = __webpack_public_path__ + "img/12.bd4abe97.jpg";